import { Link, Typography } from '@material-ui/core';
import { formatDateGeneric } from 'utilities/common';
import { makeStyles } from '@material-ui/core/styles';
import DashboardDataTable from 'modules/common/dashboardDataTable.component';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  daysOverdue: {
    fontWeight: 'bold',
    color: theme.palette.error.main,
  },
  fileLink: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  vipStar: {
    color: theme.palette.warning.main,
    marginLeft: theme.spacing(0.5),
  },
  noData: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
}));

const OverdueTasksGrid = ({ tasks, isLoading, onFileClick }) => {
  const classes = useStyles();

  const columns = [
    { accessorKey: 'rcName', header: 'RC Name' },
    { accessorKey: 'taskTitle', header: 'Task Title' },
    {
      accessorKey: 'fileNumber',
      header: 'File #',
      Cell: ({ row }) => (
        <Link
          className={classes.fileLink}
          onClick={() => onFileClick(row.original.fileId)}
          color="primary"
        >
          {row.original.fileNumber}
        </Link>
      ),
    },
    { accessorKey: 'clientName', header: 'Client' },
    {
      accessorKey: 'employeeName',
      header: 'Employee',
      Cell: ({ row }) => (
        <>
          {row.original.employeeName}
          {row.original.isVIP && <span role="img" aria-label="VIP" className={classes.vipStar}>⭐</span>}
        </>
      ),
    },
    {
      accessorKey: 'dueDate',
      header: 'Due Date',
      Cell: ({ cell }) => (cell.getValue() ? formatDateGeneric(cell.getValue()) : 'N/A'),
    },
    {
      accessorKey: 'daysOverdue',
      header: 'Days Overdue',
      muiTableBodyCellProps: { className: classes.daysOverdue },
    },
    { accessorKey: 'taskTypeName', header: 'Task Type' },
  ];

  if (isLoading) {
    return (
      <Typography className={classes.noData} color="textSecondary">
        Loading tasks...
      </Typography>
    );
  }

  if (tasks.length === 0) {
    return (
      <Typography className={classes.noData} color="textSecondary">
        No overdue tasks found.
      </Typography>
    );
  }

  return (
    <DashboardDataTable
      columns={columns}
      data={tasks}
      initialSorting={[{ id: 'daysOverdue', desc: true }]}
    />
  );
};

OverdueTasksGrid.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      taskId: PropTypes.number.isRequired,
      rcName: PropTypes.string.isRequired,
      taskTitle: PropTypes.string.isRequired,
      fileNumber: PropTypes.string.isRequired,
      fileId: PropTypes.number.isRequired,
      clientName: PropTypes.string,
      employeeName: PropTypes.string,
      dueDate: PropTypes.string,
      daysOverdue: PropTypes.number,
      taskTypeName: PropTypes.string,
      isVIP: PropTypes.bool,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFileClick: PropTypes.func.isRequired,
};

export default OverdueTasksGrid;
